import { Role, Team, User } from 'api/models';
import { RoleOption } from '../role-selection';

const getUsersInRole = (users: User[], roleId: number): User[] =>
  users.filter(({ role }) => role?.roleId === roleId);

export const getUserRoleOptions = (
  roles: Role[],
  users: User[],
): RoleOption[] =>
  roles.map((role) => ({
    ...role,
    numberOfEntities: getUsersInRole(users, role.roleId).length,
  }));

export const getPlaceholderRoleOptions = (
  roles: Role[],
  teams: Team[],
): RoleOption[] =>
  roles.map((role) => ({
    ...role,
    numberOfEntities: teams.filter(
      (item) => item.roleId && item.roleId === role.roleId,
    ).length,
  }));
